import { ConnectedAccountResponseDto, updateConnectedAccountMutation } from '@helios/frontend-api-v2-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getFriendlyError } from '../../utils/error';
import { QUERY_KEY_CONNECTED_ACCOUNTS } from './useConnectedAccounts';

interface UseUpdateConnectedAccountStatusProps {
  updateStatus: (connectedAccountId: string, status: ConnectedAccountResponseDto['status']) => Promise<void>;
  isLoading: boolean;
  error: string | null;
  isSuccess: boolean;
}

export const useUpdateConnectedAccountStatus = (): UseUpdateConnectedAccountStatusProps => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, error, isSuccess } = useMutation({
    ...updateConnectedAccountMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_CONNECTED_ACCOUNTS() });
    },
  });

  const updateStatus = async (connectedAccountId: string, status: ConnectedAccountResponseDto['status']) => {
    await mutateAsync({ path: { id: connectedAccountId }, body: { status } });
  };

  return {
    updateStatus,
    isLoading: isPending,
    error: getFriendlyError(error as AxiosError, 'Update Connected Account Status') || null,
    isSuccess,
  };
};
